/**
 *
 */
export enum ECHARTS_SYMBOL {
  rect = 'rect',
  diamond = 'diamond',
  none = 'none',
  triangle = 'triangle',
}
